
import React, { Component } from 'react';
import { Checkbox } from 'antd';


class CheckItem extends Component {
	handleChange = (e) => {
		if (this.props.onChange) {
			this.props.onChange(e.target.checked);
		}
	}

	render() {
		const { onChange, ...restProps } = this.props;
		return (
            <Checkbox
				{...restProps}
				onChange={this.handleChange}
				className={`checkitemForm ${this.props.className || ''}`}
			>
                {this.props.children}
            </Checkbox>
		);
	}
}

export default CheckItem;